import React, { useCallback, useEffect, useState } from 'react';
import { useFocusEffect, useNavigation } from '@react-navigation/native';
import { ScheduleSuccess } from '../../ScheduleSuccess';
import { ScheduleLocal } from './ScheduleLocal';
import { ScheduleSpecialty } from './ScheduleSpecialty';
import { ScheduleDate } from './ScheduleDate';
import { ScheduleUploadExamEmpty } from './ScheduleUploadExamEmpty';
import { ScheduleUploadExam } from './ScheduleUploadExam';
import { SelectDependents } from './SelectDependents/SelectDependents';
import { BmgScheduleDate } from './Bmg/BmgScheduleDate/Index';
import { DoctorsList } from './Bmg/DoctorsList';
import { ScheduleLocalType } from './ScheduleLocalType';
import { SchedulePreference } from './SchedulePreference';

import { ScheduleReview } from './ScheduleReview';
import { ScheduleUnit } from './ScheduleUnit';
import { ScheduleUploadExamFiles } from './ScheduleUploadExamFiles';
import StethoscopeIcon from '~/components/Icons/Stethoscope';
import ExamIcon from '~/components/Icons/Exam';
import VideoIcon from '~/components/Icons/Video';
import { trackingEventType } from '~/contexts/tracking/types';
import { AppointmentFlowType, TypesEnum } from '~/enums/appointment';
import { useAppointment } from '~/hooks/appointment';
import { ItemType } from '~/components/@tem-ui/Stepper/types';
import { useAuth } from '~/auth/legacy/useAuth';
import { useStepper } from '~/components/@tem-ui/Stepper';
import ToothIcon from '~/components/Icons/ToothIcon';
import CheckUpIcon from '~/components/Icons/CheckUpIcon';
import { isMercadoPagoOnix } from '~/helpers/mercado-pago';
import { ScheduleTelemedicineSpecialty } from '~/screens/VideoAppointmentsSchedule/conexa-telemedicine/ScheduleTelemedicineSpecialty';
import { ScheduleTelemedicineDoctor } from '~/screens/VideoAppointmentsSchedule/conexa-telemedicine/ScheduleTelemedicineDoctor';
import { TelemedicineScheduleDate } from '~/screens/VideoAppointmentsSchedule/conexa-telemedicine/TelemedicineScheduleDate/Index';
import { isPicpayOnix, PICPAY_ONIX } from '~/helpers/picpay';
import { DeepLink } from '~/auth/strategies/deep-link/deep-link-utils';
import { DeepLinkEvent } from '~/auth/strategies/deep-link/enums/deep-link-event';
import { isPagBankOnix, PAGBANK_ONIX } from '~/helpers/pagbank';
import { BMG_ONIX } from '~/helpers/bmg';
import { useCheckupContext } from '~/contexts/checkup';

export const scheduleType = (): ItemType[] => {
  const { checkIsEnabledFeature, onixCode, dependents, user } = useAuth();
  const [flowDate, setFlowDate] = useState<boolean>(false);
  const [availableForDependents, setAvailableForDependents] = useState<boolean>(false);
  const navigation = useNavigation();
  const { stepper } = useStepper();
  const { patientCpf, isDeepLink } = DeepLink.useParams();
  const { specialties, getSpecialities, setCheckupType } = useCheckupContext();
  const { appointment, setAppointment, setPatient } = useAppointment();

  useEffect(() => {
    if (stepper !== null) {
      setFlowDate(false);
    }
  }, [stepper]);

  useFocusEffect(
    useCallback(() => {
      if (checkIsEnabledFeature('check-up_presencial')) {
        setCheckupType('checkup')
      } 
      if (isDeepLink && patientCpf) {
        const userDocument = user?.cpf.replace(/\D/g, '');
        const isTitular = patientCpf === userDocument;
        const patientDependent =
          dependents && !isTitular
            ? dependents.find((dependent) => dependent.cpf === patientCpf && dependent.status === 1)
            : undefined;

        setPatient({
          id: patientCpf,
          cpf: isTitular ? user?.cpf : patientDependent?.cpf,
          name: isTitular ? user?.name : patientDependent?.name,
          birthdate: isTitular ? user?.birthdate : patientDependent?.birthdate,
          isTitular,
        });

        setAvailableForDependents(false);
      } else {
        setAvailableForDependents(
          checkIsEnabledFeature('dependents') &&
          Array.isArray(dependents) &&
          dependents.some((dependent) => dependent.status === 1),
        );
      }
    }, [dependents, patientCpf]),
  );

  useEffect(() => {
    flowDate &&
      appointment &&
      setAppointment({ ...appointment, flowType: AppointmentFlowType.Indications });
  }, [flowDate]);

  const { submitTelemedicineAppointment } = useAppointment();

  const checkAppoitmentB2C = useCallback(() => {
    if (isPagBankOnix(onixCode?.onixCode)) {
      return [
        <ScheduleSpecialty key="ScheduleSpecialty" />,
        <ScheduleLocalType key="ScheduleLocalType" />,
        <ScheduleLocal key="ScheduleLocal" />,
        <ScheduleDate key="ScheduleDate" />,
        <SelectDependents key="SelectDependent" />,
        <ScheduleReview
          key="ScheduleReview"
          scheduleType={TypesEnum.Appointment}
          trackingType={trackingEventType.RequestedInPresentialAppointment}
        />,
        <ScheduleSuccess key="presentionSuccess" />,
      ];
    }
    return [
      <ScheduleSpecialty key="ScheduleSpecialty" />,
      // <ScheduleLocalType key="ScheduleLocalType" />,
      <ScheduleLocal key="ScheduleLocal" />,
      // <SchedulePreference key="SchedulePreference" setFlowDate={() => setFlowDate(true)} />,
      // ...(!flowDate
      //   ? [<ScheduleUnit key="ScheduleUnit" />, <ScheduleDate key="ScheduleDate" />]
      //   : [<ScheduleDate key="ScheduleDate" />]),
      <ScheduleDate key="ScheduleDate" />,
      <SelectDependents key="SelectDependent" />,
      <ScheduleReview
        key="ScheduleReview"
        scheduleType={TypesEnum.Appointment}
        trackingType={trackingEventType.RequestedInPresentialAppointment}
      />,
      <ScheduleSuccess key="presentionSuccess" />,
    ];
  }, [flowDate]);

  const checkExamtB2C = useCallback(() => {
    if (isPagBankOnix(onixCode?.onixCode)) {
      return [
        appointment?.notFoundAttatchment ? (
          <ScheduleUploadExamEmpty key="ScheduleUploadExamEmpty" />
        ) : (
          <ScheduleUploadExam key="ScheduleUploadExam" stepperData={presentialAppointment} />
        ),
        <ScheduleUploadExamFiles key="ScheduleUploadExamFiles" />,
        <ScheduleLocalType key="ScheduleLocalType" />,
        <ScheduleLocal key="ScheduleLocal" />,
        <ScheduleDate key="ScheduleDate" />,
        <SelectDependents key="SelectDependent" />,
        <ScheduleReview
          key="ScheduleReview"
          scheduleType={TypesEnum.Exam}
          trackingType={trackingEventType.RequestedInPresentialAppointment}
        />,
        <ScheduleSuccess key="ScheduleSuccess" />,
      ];
    }
    return [
      appointment?.notFoundAttatchment ? (
        <ScheduleUploadExamEmpty key="ScheduleUploadExamEmpty" />
      ) : (
        <ScheduleUploadExam key="ScheduleUploadExam" stepperData={presentialAppointment} />
      ),
      <ScheduleUploadExamFiles key="ScheduleUploadExamFiles" />,
      <ScheduleLocalType key="ScheduleLocalType" />,
      <ScheduleLocal key="ScheduleLocal" />,
      <SchedulePreference key="SchedulePreference" setFlowDate={() => setFlowDate(true)} />,
      ...(!flowDate
        ? [<ScheduleUnit key="ScheduleUnit" />, <ScheduleDate key="ScheduleDate" />]
        : [<ScheduleDate key="ScheduleDate" />]),
      <SelectDependents key="SelectDependent" />,
      <ScheduleReview
        key="ScheduleReview"
        scheduleType={TypesEnum.Exam}
        trackingType={trackingEventType.RequestedInPresentialAppointment}
      />,
      <ScheduleSuccess key="ScheduleSuccess" />,
    ];
  }, [flowDate, appointment?.notFoundAttatchment]);

  const handleDentistry = () => {
    if (isPagBankOnix(onixCode?.onixCode)) {
      return [
        <ScheduleLocal key="ScheduleLocal" />,
        <ScheduleDate key="ScheduleDate" />,
        <SelectDependents key="SelectDependent" />,
        <ScheduleReview
          key="ScheduleReview"
          specialtyName="odontologia"
          scheduleType={TypesEnum.Dentistry}
          trackingType={trackingEventType.RequestedInDentalConsultationsAndProcedures}
        />,
        <ScheduleSuccess key="presentionSuccess" />,
      ];
    }
    return [
      <ScheduleLocal key="ScheduleLocal" />,
      ...(!flowDate
        ? [
          <ScheduleUnit key="ScheduleUnit" specialty={{ name: 'odontologia', id: String(28) }} />,
          <ScheduleDate key="ScheduleDate" />,
        ]
        : [<ScheduleDate key="ScheduleDate" />]),
      <SelectDependents key="SelectDependent" />,
      <ScheduleReview
        key="ScheduleReview"
        specialtyName="odontologia"
        scheduleType={TypesEnum.Dentistry}
        trackingType={trackingEventType.RequestedInDentalConsultationsAndProcedures}
      />,
      <ScheduleSuccess key="presentionSuccess" />,
    ];
  };
  const presentialAppointment = {
    icon: <StethoscopeIcon />,
    title: 'Consulta Presencial',
    description: 'Especialidades médicas e terapias',
    customTitle: 'Solicitação de consulta',
    description: 'Especialidades médicas e terapias',
    disabled: !checkIsEnabledFeature('health_network'),
    visible: checkIsEnabledFeature('health_network'),
    visibilitySteps: false,
    steps: checkAppoitmentB2C(),
    tracking: trackingEventType.ClickedOnPresentialAppointment,
    iconSideOfTitle: true,
  };

  const telemedicineDefault = [
    <ScheduleSpecialty key="ScheduleSpecialty" isTelemedicine={true} />,
    <ScheduleDate key="ScheduleDate" />,
    ...(availableForDependents ? [<SelectDependents key="SelectDependent" />] : []),
    <ScheduleReview
      key="ScheduleReview"
      scheduleType={TypesEnum.Video}
      trackingType={trackingEventType.RequestedInVideoAppointment}
    />,
    <ScheduleSuccess key="ScheduleSuccess" />,
  ];

  const telemedicineSemCopart = [
    <ScheduleTelemedicineSpecialty key="ScheduleTelemedicineSpecialty" />,
    <ScheduleTelemedicineDoctor key="ScheduleTelemedicineDoctor" />,
    <TelemedicineScheduleDate key="TelemedicineScheduleDate" />,
    ...(availableForDependents ? [<SelectDependents key="SelectDependent" />] : []),
    <ScheduleReview
      key="ScheduleReview"
      scheduleType={TypesEnum.Video}
      trackingType={trackingEventType.RequestedInVideoAppointment}
      customSubmit={submitTelemedicineAppointment}
    />,
    <ScheduleSuccess key="ScheduleSuccess" />,
  ];

  const telemedicineBot = [
    <ScheduleTelemedicineDoctor key="ScheduleTelemedicineDoctor" />,
    <TelemedicineScheduleDate key="TelemedicineScheduleDate" />,
    ...(availableForDependents ? [<SelectDependents key="SelectDependent" />] : []),
    <ScheduleReview
      key="ScheduleReview"
      scheduleType={TypesEnum.Video}
      trackingType={trackingEventType.RequestedInVideoAppointment}
      customSubmit={submitTelemedicineAppointment}
    />,
    <ScheduleSuccess key="ScheduleSuccess" />,
  ];

  const handleTelemedicineSteps = () => {
    if (
      [...PICPAY_ONIX, ...PAGBANK_ONIX, ...BMG_ONIX].includes(
        onixCode?.onixCode.toString() || '',
      ) &&
      isDeepLink
    )
      return telemedicineBot;

    if (checkIsEnabledFeature(['telemedicine_semcopart', 'programa_nutricional'])) return telemedicineSemCopart;

    return telemedicineDefault;
  };

  const handleCheckup = useCallback(() => {
    return isMercadoPagoOnix(onixCode?.onixCode) && [
         ...(specialties.length > 1
                ? [<ScheduleSpecialty isCheckup={true} isTelemedicine={checkIsEnabledFeature('check-up_telemedicina')} key="ScheduleSpecialty" />]
                : []),
         ...(availableForDependents ? [<SelectDependents key="SelectDependent" />] : []),
         <ScheduleReview
           key="ScheduleReview"
           specialtyName="checkup"
           scheduleType={TypesEnum.CheckUp}
           trackingType={trackingEventType.RequestedInDentalConsultationsAndProcedures}
         />,
         <ScheduleSuccess key="presentionSuccess" />,
       ]
   }, []);
 

  return [
    presentialAppointment,
    {
      icon: <ExamIcon />,
      title: 'Exames e Procedimentos',
      description: 'Lista de laboratórios e exames',
      customTitle: 'Solicitação de exames',
      description: 'Lista de laboratórios e exames',
      disabled: !checkIsEnabledFeature('health_network'),
      visible: checkIsEnabledFeature('health_network'),
      visibilitySteps: false,
      steps: checkExamtB2C(),
      tracking: trackingEventType.ClickedOnExamAppointment,
      iconSideOfTitle: true,
    },
    {
      icon: <VideoIcon />,
      title: 'Consulta por vídeo',
      description: 'Telemedicina com especialidades médicas',
      customTitle: 'Agendar consulta por vídeo',
      disabled: !checkIsEnabledFeature('telemedicine'),
      visible: checkIsEnabledFeature('telemedicine'),
      visibilitySteps: false,
      tracking: trackingEventType.ClickedOnVideoAppointment,
      steps: handleTelemedicineSteps(),
      iconSideOfTitle: true,
    },
    {
      icon: <VideoIcon />,
      title: 'Psicologia por Vídeo',
      description: 'Telemedicina com psicólogos',
      customTitle: 'Solicitação terapia por vídeo',
      description: 'Telemedicina com psicólogos',
      disabled: !checkIsEnabledFeature('psicologia_online'),
      visible: checkIsEnabledFeature('psicologia_online'),
      visibilitySteps: false,
      tracking: trackingEventType.ClickedOnPsychologicalVideoTherapy,
      steps: [
        <ScheduleDate key="ScheduleDate" />,
        <SelectDependents key="SelectDependent" />,
        <ScheduleReview
          key="ScheduleReview"
          scheduleType={TypesEnum.VideoPsychology}
          trackingType={trackingEventType.RequestedInPsychologicalVideoTherapy}
          specialtyName="psicologia"
        />,
        <ScheduleSuccess key="presentionSuccess" />,
      ],
      iconSideOfTitle: true,
    },
    {
      icon: <ToothIcon />,
      title: 'Consulta Odontológica',
      description: 'Especialidades odontológicas',
      disabled: !checkIsEnabledFeature('dentistry'),
      visible: checkIsEnabledFeature('dentistry'),
      visibilitySteps: false,
      steps: handleDentistry(),
      tracking: trackingEventType.ClickedOnDentalConsultationsAndProcedures,
      iconSideOfTitle: true,
    },
    {
      icon: <CheckUpIcon />,
      title: 'Check-Up Médico',
      onPress: () => navigation.navigate('BenefitsCheckup'),
      description: 'Solicite um Check-Up Médico',
      disabled: !checkIsEnabledFeature(['checkup', 'checkup_fone', 'checkup_auto']),
      visible: checkIsEnabledFeature(['checkup', 'checkup_fone', 'checkup_auto', 'check-up_telemedicina']),
      visibilitySteps: false,
      steps:  handleCheckup(),
      tracking: trackingEventType.ClickedOnPresentialAppointment, // <- Checar a chave correta para esse item
      iconSideOfTitle: true,
    },
  ];
};
